<template>
    <section class="flex flex-col items-start p-4 rounded shadow-lg bg-white space-y-4">
        <nio-select
            class="w-full"
            :disabled="$wait.is('fetching.chatUsers')"
            :options="formattedUsers"
            :value="selectedUserId"
            @input="setSelectedUser"
            v-if="hasAccessToViewOtherUsersConversations && !$configs.inIframe"
        />

        <nio-toggle :value="isIntelligentFilterEnabled" @input="toggleIntelligentFilter($event)">
            <span class="inline-flex items-center">
                <span>{{ intelligentFilterText }}</span>
                <nio-icon class="ml-1 text-gray-600" name="bold/question-help-circle" v-tooltip="{ content: intelligentFilterTooltip, showOnMobile: true, }" />
            </span>
        </nio-toggle>

        <nio-button-group class="w-full">
            <nio-button
                class="flex-1"
                :color="showActiveConversation ? 'blue' : 'white'"
                :disabled="!!search"
                @click="toggleShowActive(true)"
                v-tooltip="$t('chat.conversationList.showActive')"
            >
                <nio-icon class="text-base" name="regular/drawer-download" />
            </nio-button>
            <nio-button
                class="flex-1"
                :color="!showActiveConversation ? 'blue' : 'white'"
                :disabled="!!search"
                @click="toggleShowActive(false)"
                v-tooltip="$t('chat.conversationList.showArchive')"
            >
                <nio-icon class="text-base" name="regular/archive" />
            </nio-button>
        </nio-button-group>
    </section>
</template>

<script>
    import { mapState, mapMutations, mapGetters } from 'vuex';
    import orderBy from 'lodash/orderBy';

    export default {
        props: {
            search: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                users: [],
                isIntelligentFilterEnabled: true,
            };
        },

        computed: {
            ...mapState([
                'authUser',
            ]),

            ...mapState('chat', [
                'selectedUserId',
                'showActiveConversation',
                'intelligentFilterEnabled',
            ]),

            ...mapGetters([
                'hasAccessToViewOtherUsersConversations',
            ]),

            intelligentFilterText() {
                return this.isIntelligentFilterEnabled
                    ? this.$t('chat.conversationList.intelligentFilterEnabled')
                    : this.$t('chat.conversationList.intelligentFilterDisabled');
            },

            intelligentFilterTooltip() {
                return this.isIntelligentFilterEnabled
                    ? this.$t('chat.conversationList.showNonActionnable')
                    : this.$t('chat.conversationList.hideNonActionnable');
            },

            formattedUsers() {
                const users = this.users.map(user => {
                    return {
                        value: user.id,
                        label: this.formatFullName(user),
                    };
                });

                return orderBy(users, 'label');
            },
        },

        watch: {
            'authUser.account.id': {
                immediate: true,
                handler(newValue) {
                    if (!newValue) {
                        return;
                    }

                    this.fetchUsers();
                },
            },
        },

        methods: {
            ...mapMutations('chat', [
                'setSelectedContactId',
                'setSelectedUserId',
            ]),

            toggleShowActive(showActive) {
                this.$emit('toggle-show-active', showActive);
            },

            toggleIntelligentFilter(isEnabled) {
                this.isIntelligentFilterEnabled = isEnabled;

                this.$emit('toggle-intelligent-filter', this.isIntelligentFilterEnabled);
            },

            async fetchUsers() {
                this.$wait.start('fetching.chatUsers');

                const response = await this.$axios.get('users', {
                    params: {
                        account_id: this.authUser.account.id,
                    },
                });

                this.users = response.data.data;

                this.$wait.end('fetching.chatUsers');
            },

            setSelectedUser(userId) {
                if (userId == this.selectedUserId) {
                    return;
                }

                this.$router.push({ name: 'chat' });
                this.setSelectedContactId(null);
                this.setSelectedUserId(userId);
            },
        },

        mounted() {
            this.isIntelligentFilterEnabled = this.intelligentFilterEnabled;
        },
    };
</script>
